import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { formatDate, renderMarkdown } from "@/lib/format";
import "@/styles/portfolio.css";
import "@/styles/blog.css";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/posts/${slug}`);
        if (!cancelled) setPost(data);
      } catch (e) {
        if (!cancelled) setError("Beitrag nicht gefunden.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return (
    <div className="blog-page" data-testid="blog-post-page">
      <header className="blog-top">
        <Link to="/blog" className="blog-back" data-testid="blog-back-to-list">
          ← Alle Beiträge
        </Link>
        <Link to="/" className="blog-logo">content.by.max</Link>
        <span className="blog-top__spacer" />
      </header>

      {loading && <p className="blog-empty">Lädt…</p>}
      {error && (
        <div className="blog-empty">
          <p>{error}</p>
          <Link to="/blog" className="btn btn--ghost" style={{ marginTop: 18 }}>
            <span>Zurück zur Übersicht</span>
            <span className="btn__arrow">→</span>
          </Link>
        </div>
      )}

      {post && (
        <article className="post" data-testid="blog-post-article">
          <header className="post__head">
            <span className="post__date">{formatDate(post.created_at)}</span>
            <h1 className="post__title">{post.title}</h1>
            <p className="post__byline">
              Von {post.author || "Max"} · content.by.max
            </p>
          </header>

          {post.cover_image && (
            <div className="post__cover">
              <img src={post.cover_image} alt={post.title} />
            </div>
          )}

          <div
            className="post__body"
            data-testid="post-body"
            dangerouslySetInnerHTML={renderMarkdown(post.body)}
          />

          <footer className="post__foot">
            <Link to="/blog" className="post__back" data-testid="post-back">
              ← Alle Beiträge
            </Link>
            <Link to="/#kontakt" className="btn btn--solid">
              <span>Jetzt anfragen</span>
              <span className="btn__arrow">→</span>
            </Link>
          </footer>
        </article>
      )}
    </div>
  );
}
